import { ThunkType } from "../../../../core/store/reducers";
import { getTradeBookExcel } from "../api/getTradeBookExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../tradesReportDataSlice"

export const downloadTradesReportExcel = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const { filter } = store.ux.reports.tradesReport;
	const user = store.data.auth.current.user;
	dispatch(setFetchState({ type: "started"}))
	const tradesReport = await dispatch(getTradeBookExcel(user, filter));
	if (tradesReport) {
		fileDownload(new Blob([tradesReport as any], { type: "application/vnd.openxmlformat" }), "TradeBook.xlsx");
	}
	dispatch(setFetchState({ type: "not-started"}))
};
